import { Image as ExpoImage } from "expo-image";
import React, { useCallback, useRef, useState } from "react";
import { Animated, Platform, View } from "react-native";
import { Skeleton } from "@lookiero/aurora";
import { style } from "./LazyImage.style";
const RESIZE_MODE_TO_CONTENT_FIT = {
    cover: "cover",
    contain: "contain",
    stretch: "fill",
    center: "none",
    repeat: "cover",
};
const mapResizeMode = (resizeMode) => RESIZE_MODE_TO_CONTENT_FIT[resizeMode ?? "cover"] ?? "cover";
const LazyImage = ({ src, hiResSrc, style: customStyle, testID, resizeMode, onLoad, ...restProps }) => {
    const [loaded, setLoaded] = useState(false);
    const uri = hiResSrc ?? src;
    const contentFit = mapResizeMode(resizeMode);
    const handleOnLoad = useCallback((event) => {
        setLoaded(true);
        onLoad?.(event);
    }, [onLoad]);
    const webOpacity = useRef(new Animated.Value(0)).current;
    const handleWebOnLoad = useCallback(() => {
        setLoaded(true);
        Animated.timing(webOpacity, { toValue: 1, duration: 300, useNativeDriver: false }).start();
    }, [webOpacity]);
    return (React.createElement(View, { style: [style.view, customStyle?.view], testID: testID },
        !loaded && React.createElement(Skeleton, { style: style.skeleton, testID: "lazy-image-skeleton" }),
        Platform.OS === "web" ? (React.createElement(Animated.Image, { resizeMode: resizeMode ?? "cover", source: { uri }, style: [style.image, customStyle?.image, { opacity: webOpacity }], testID: "lazy-image-image", onLoad: handleWebOnLoad })) : (React.createElement(ExpoImage, { ...restProps, cachePolicy: "memory-disk", contentFit: contentFit, onLoad: handleOnLoad, placeholder: { uri: src }, placeholderContentFit: contentFit, source: { uri }, style: [style.image, customStyle?.image], testID: "lazy-image-image", transition: { duration: 300, effect: "cross-dissolve" } }))));
};
export { LazyImage };
